/**
 * ENVironment settings
 */
export const env = {
  // ENVs do Back
  url: process.env.VUE_APP_MS_URL,
  baseDocumento: process.env.VUE_APP_MS_BASEDOCUMENTO,
  baseIdentificacao: process.env.VUE_APP_MS_BASEIDENTIFICACAO,
  baseDp: process.env.VUE_APP_MS_BASEDP,
  baseAtendimento: process.env.VUE_APP_MS_BASEATENDIMENTO,

  // ENVs do Front. SEM protocolo
  econtadorFront: process.env.VUE_APP_URL_ECONTADORFRONT,

  // ENVs de Componentes. COM protocolo
  componenteMenu: process.env.VUE_APP_WC_ECONTADORMENU
}
